import HotspotsManager from "./classes/HotspotsManager.js";

let hotspotsManager;

/**
 *
 * @param {Spinner} spinner
 * @param {boolean} [withButton]
 * @returns {void}
 */
export function setupHotspotsControl(spinner, withButton = true) {
  if (!spinner.hasHotspots || spinner.hideHotspots) {
    hotspotsManager?.setLabels([]);
    hotspotsManager = null;
    return;
  }

  if (hotspotsManager) {
    hotspotsManager.setLabels(spinner.availableLabels);
    return;
  }

  if (withButton) {
    const hotspotsToggle = spinner.addActionButton("hotspots-toggle", () => {
      hotspotsToggle.classList.toggle("active");
      spinner.hotspotsActive = spinner.hotspotsLayer.visibility =
        hotspotsToggle.classList.contains("active");
    });
    hotspotsToggle.classList.add("active");
    hotspotsToggle.innerHTML =
      '<span class="text">Hotspots</span><div class="hotspot"><span class="pulse"></span></div>';
  }

  hotspotsManager = new HotspotsManager(spinner);
  hotspotsManager.setLabels(spinner.availableLabels);

  spinner.renderer.addOnUpdate(() => {
    const layerHotspots = spinner.hotspots[spinner.activeLayer.type];
    hotspotsManager.render(
      layerHotspots ? layerHotspots[spinner.activeImage.id] || {} : {},
    );
  });
}
